module.exports = __webpack_public_path__ + "img/1.951215d5.png";